module.exports = __webpack_public_path__ + "img/file.723147f.svg";